<template>
  <div class="statistics">
    <div class="row">
      <div class="key">应付款:</div>
      <div class="val">{{ statistics.shouldPay.toFixed(2) }}</div>
    </div>
    <div class="row">
      <div class="key">客户付款:</div>
      <div class="val">{{ statistics.clientTotal.toFixed(2) }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },

  },
  computed: {
    statistics() {
      let total = {
        shouldPay: 0,
        clientTotal: 0,
      }
      this.checkedList.forEach(item => {
        total.shouldPay += item.shouldPay - 0
        total.clientTotal += item.clientTotal - 0

      })

      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>